import { useContext } from 'react';

import { CustomerReportContext } from 'components/grace/Contexts';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import { MODAL_TYPES } from 'lib/constants';

import GraceListRowButton from './ListRowButton';

const GraceAdditionalSteps = () => {
  const { setCurrentModal, startReport, currentStage } = useContext(CustomerReportContext);
  const openHelpInterstitial = () => {
    setCurrentModal(MODAL_TYPES.cs);
  };
  // hardcoding options for now since we are on a resolution stage
  const initialStageOption = { name: 'Report another issue', id: 'report-another' };
  const initializeChatOption = { name: 'Chat with customer support' };
  const mealWithoutExpDate = { name: "My meal doesn't have an expiration date printed" };
  const mealPastExpDate = { name: 'My meal is past its expiration date' };

  const displayFindExpirationOptions = () => {
    return currentStage.slug === 'find-exp-date-tempo';
  };

  const logReportAnother = useAnalyticsCallback(
    startReport,
    ({ logEvent, events }) => {
      logEvent(events.grace.resolutionClicked, { resolution_option: initialStageOption.name });
    },
    []
  );

  return (
    <div className="mb-4 py-2">
      <section className="mx-4">
        <svg width="100%" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="7" height="1" fill="#D8DADC" className="w-full" />
        </svg>
      </section>
      <section className="mb-6 px-6">
        <p className="h6 mt-2">Is there anything else we can help with?</p>
      </section>
      {displayFindExpirationOptions() && (
        <>
          <section className="mx-4">
            <GraceListRowButton option={mealWithoutExpDate} onClick={openHelpInterstitial} />
          </section>
          <section className="mx-4">
            <GraceListRowButton option={mealPastExpDate} onClick={openHelpInterstitial} />
          </section>
        </>
      )}
      <section className="mx-4">
        <GraceListRowButton option={initialStageOption} onClick={logReportAnother} />
      </section>
      <section className="mx-4">
        <GraceListRowButton option={initializeChatOption} onClick={openHelpInterstitial} />
      </section>
    </div>
  );
};

export default GraceAdditionalSteps;
